import React,{ useState ,useEffect}  from 'react'
import Header from '../Component/Header';
import Footer from '../Component/footer';
import {GetAction} from '../Component/GetAction'
import Imggallery from '../Component/imggallery';

function Gallary() {
  const [getDetails,setDetails] = useState([])
  const [loading,setLoading] = useState(true)
  
  const requestAPI = async () => {
    try {
    const url = `/gallary/gallaryList`;
    let reqParam = {
    }
    const res = await GetAction('get',reqParam,url)
    const response = res?.response
    setDetails(Array.isArray(response) ? response : [])
    } finally {
    setLoading(false)
    }
    }
useEffect(()=>{
    requestAPI();
},[]);  

  return (
    <>
    <Header />
    <div className='container my-3'  style={{fontSize:25,minHeight:"600px"}}>
    {loading ? <p className="text-center text-muted">Loading gallery...</p> : null}
    {!loading ? <Imggallery gallaryData={getDetails} /> : null}
    </div>
     <Footer /> 
    </>
  )
}

export default Gallary
